import styled from 'styled-components'

import { CHECKBOX_BOX_SIZE_MAP } from './checkbox.constants'
import { CheckboxSize } from './checkbox.types'

export const CheckboxLabel = styled.label<{ $disabled: boolean }>(({ theme, $disabled }) => ({
  alignItems: 'center',
  cursor: $disabled ? 'not-allowed' : 'pointer',
  display: 'inline-flex',
  gap: theme.space['8'],
  position: 'relative',
}))

export const CheckboxInput = styled.input({
  height: 0,
  opacity: 0,
  pointerEvents: 'none',
  position: 'absolute',
  width: 0,
})

export const CheckboxBox = styled.div<{
  $checked: boolean
  $disabled: boolean
  $size: CheckboxSize
}>(({ theme, $checked, $disabled, $size }) => {
  // Note: per the design system's Checkbox - unchecked is a gray200 fill with a 1px gray700
  // border, checked/indeterminate a solid primary800 fill. With `border-box` the 1px border
  // puts the 16px/12px check icon at the design's 2px inset.
  // Note: no hover state - the design's Checkbox defines none, and the old darker hover borders
  // (black500/black700) don't belong to its palette.
  return {
    alignItems: 'center',
    backgroundColor: $checked ? theme.colors.primary800 : theme.colors.gray200,
    border: `${theme.border.size['1']} solid ${
      $checked ? theme.colors.primary800 : theme.colors.gray700
    }`,
    borderRadius: theme.border.radius['4'],
    boxSizing: 'border-box',
    display: 'flex',
    height: CHECKBOX_BOX_SIZE_MAP[$size],
    justifyContent: 'center',
    opacity: $disabled ? 0.5 : 1,
    position: 'relative',
    transition: `background-color ${theme.transition.duration.sm}, border-color ${theme.transition.duration.sm}`,
    width: CHECKBOX_BOX_SIZE_MAP[$size],
  }
})

export const CheckboxLabelText = styled.span<{
  $disabled: boolean
  $size: CheckboxSize
}>(({ theme, $disabled, $size }) => {
  const fontSizeMap = {
    medium: '1.4rem',
    small: '1.2rem',
  }

  const lineHeightMap = {
    medium: '2rem',
    small: '1.6rem',
  }

  return {
    color: $disabled ? theme.colors.black200 : theme.colors.black800,
    fontSize: fontSizeMap[$size],
    lineHeight: lineHeightMap[$size],
    userSelect: 'none',
  }
})
